import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faCoffee,
  faBreadSlice,
  faDrumstickBite,
  faStore,
  faUtensils,
  faIceCream,
  faFish,
  faCookie,
  faBowlRice,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const businessAreas = [
  { name: "Coffee Shop", icon: faCoffee, path: "/cofee" },
  { name: "Bakery & Pastry", icon: faBreadSlice, path: "/bakerypastry" },
  { name: "Butchery & Charcuterie", icon: faDrumstickBite, path: "/butchery" },
  { name: "Supermarket & C-Stores", icon: faStore, path: "/supermarket" },
  { name: "Take-Away", icon: faUtensils, path: "/takeaway" },
  { name: "Restaurant & Self-Service", icon: faUtensils, path: "/restaurent" },
  { name: "Chocolate", icon: faCookie, path: "/choclote" },
  { name: "Ice Cream", icon: faIceCream, path: "/icecream" },
  { name: "Sushi", icon: faBowlRice, path: "/sushi" },
  { name: "Fish & Seafood", icon: faFish, path: "/seafood" },
];

const BusinessShowcase = () => {
  const navigate = useNavigate();
  const [startIndex, setStartIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(6);

  // Adjust items per page based on screen size
  useEffect(() => {
    const updateItemsPerPage = () => {
      if (window.innerWidth < 640) setItemsPerPage(2);
      else if (window.innerWidth < 768) setItemsPerPage(3);
      else if (window.innerWidth < 1024) setItemsPerPage(4);
      else if (window.innerWidth < 1280) setItemsPerPage(5);
      // else if (window.innerWidth < 1536) setItemsPerPage(6);


      else setItemsPerPage(6);
    };

    updateItemsPerPage();
    window.addEventListener("resize", updateItemsPerPage);
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

  const handleNext = () => {
    if (startIndex + itemsPerPage < businessAreas.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrev = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  return (
    <section className="py-12 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-8">
          Our Business Areas
        </h2>

        <div className="flex flex-col items-center">
         

          {/* Business Cards Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6  gap-6">
            {businessAreas.slice(startIndex, startIndex + itemsPerPage).map((business, index) => (
              <div
                key={index}
                onClick={() => navigate(business.path)}
                className="flex flex-col items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition w-36 h-32 sm:w-40 sm:h-36 md:w-44 md:h-40 duration-300 transform hover:-translate-y-2 cursor-pointer"
              >
                <FontAwesomeIcon icon={business.icon} className="text-primary text-3xl md:text-4xl mb-3" />
                <h3 className="text-sm md:text-lg font-semibold text-gray-700 text-center">{business.name}</h3>
              </div>
            ))}
          </div>

           {/* Navigation Buttons */}
           <div className="flex items-center gap-4 mt-6">
            <button
              onClick={handlePrev}
              disabled={startIndex === 0}
              className="p-3 rounded-full bg-gray-300 hover:bg-gray-400 disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronLeft} className="text-lg" />
            </button>
            <button
              onClick={handleNext}
              disabled={startIndex + itemsPerPage >= businessAreas.length}
              className="p-3 rounded-full bg-gray-300 hover:bg-gray-400 disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronRight} className="text-lg" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessShowcase;
